const economy = {
    namespaced:true,
    state: () => ({
        economyData: true , //保存经济效益状态
        animalTypeName:'', //保存动物类型名称
        predictionType:'' //保存动物类型
    }),
    mutations:{
      setEconomyData(state, action){
        state.economyData =  action
      },
      setAnimalTypeName(state, action){
        state.animalTypeName=  action
      },
      setPredictionType(state, action){
        state.predictionType=  action
      }
    }
  }
  
export default economy